module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 9.9c5bb33c.png";